/*
  Quick JS by Jason @ freakdesign.
  https://freakdesign.com.au/blogs/news/get-shipping-estimates-on-a-product-page
*/
(function () {
  "use strict";

  var PROVINCES = {
    AC: "Acre",
    AL: "Alagoas",
    AP: "Amapa",
    AM: "Amazonas",
    BA: "Bahia",
    CE: "Ceara",
    DF: "Distrito Federal",
    ES: "Espirito Santo",
    GO: "Goias",
    MA: "Maranhao",
    MT: "Mato Grosso",
    MS: "Mato Grosso do Sul",
    MG: "Minas Gerais",
    PA: "Para",
    PB: "Paraiba",
    PR: "Parana",
    PE: "Pernambuco",
    PI: "Piaui",
    RJ: "Rio de Janeiro",
    RN: "Rio Grande do Norte",
    RS: "Rio Grande do Sul",
    RO: "Rondonia",
    RR: "Roraima",
    SC: "Santa Catarina",
    SP: "Sao Paulo",
    SE: "Sergipe",
    TO: "Tocantins",
  };

  var cartCookie;

  var productSection = document.getElementsByClassName("frete-produto");
  if (!productSection.length) {
    return;
  }

  var productSelect =
    document.querySelector('product-form.productView-form [name="id"]') ||
    document.getElementById("ProductSelect-product-template") ||
    document.getElementsByName("id")[0];
  if (!productSelect) {
    return;
  }

  var shippingMessage = document.createElement("p");
  var shippingCountry = document.createElement("select");
  var shippingProvince = document.createElement("select");
  var shippingZip = document.createElement("input");
  var freteLista = document.createElement("div");
  var shippingCalcButton = document.createElement("button");

  shippingMessage.className = "erros-fretes";
  shippingMessage.setAttribute("role", "status");
  shippingMessage.setAttribute("style", "display:none");

  freteLista.className = "listas-de-fretes";
  freteLista.setAttribute("aria-live", "polite");
  freteLista.setAttribute("style", "display:none");

  var showError = function (text) {
    freteLista.innerHTML = "";
    freteLista.setAttribute("style", "display:none");
    shippingMessage.textContent = text;
    shippingMessage.setAttribute("style", "display:flex");
  };

  var clearError = function () {
    shippingMessage.textContent = "";
    shippingMessage.setAttribute("style", "display:none");
  };

  var setLoading = function (isLoading) {
    shippingCalcButton.classList.toggle("is-loading", isLoading);
  };

  var getCookie = function (name) {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  };

  var updateCartCookie = function (value) {
    var date = new Date();
    date.setTime(date.getTime() + 14 * 86400000);
    document.cookie =
      "cart=" + value + "; expires=" + date.toGMTString() + "; path=/";
  };

  var resetCartCookie = function () {
    updateCartCookie(cartCookie);
  };

  var isDateBeforeToday = function (date) {
    return new Date(date.toDateString()) < new Date(new Date().toDateString());
  };

  var formatDeliveryDate = function (date) {
    return (
      date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear()
    );
  };

  var describeDelivery = function (rate) {
    var deliveryDays = rate.delivery_days || [];
    if (deliveryDays.length) {
      return "Até " + Math.max.apply(null, deliveryDays) + " dia(s) úteis";
    }

    if (rate.delivery_date) {
      var deliveryDate = new Date(rate.delivery_date);
      if (!isDateBeforeToday(deliveryDate)) {
        return "Chega até " + formatDeliveryDate(deliveryDate);
      }
    }

    return "Estimativa de entrega indisponível";
  };

  var describePrice = function (rate) {
    if (rate.price == "0.00" || rate.price == null) {
      return "Grátis";
    }
    return Shopify.formatMoney(rate.price, "R$ {{amount_with_comma_separator}}");
  };

  var renderRates = function (rates) {
    freteLista.innerHTML = "";

    if (!rates.length) {
      var empty = document.createElement("p");
      empty.className = "frete-vazio";
      empty.textContent = "Não encontramos opções de entrega para este CEP.";
      freteLista.appendChild(empty);
      freteLista.setAttribute("style", "display:block");
      return;
    }

    rates.forEach(function (rate) {
      var item = document.createElement("div");
      item.className = "frete-item";

      var info = document.createElement("div");

      var name = document.createElement("p");
      name.className = "nome-frete";

      var nameText = document.createElement("b");
      nameText.textContent = rate.name;

      var estimate = document.createElement("span");
      estimate.className = "estimativa-de-entrega";
      estimate.textContent = describeDelivery(rate);

      name.appendChild(nameText);
      name.appendChild(estimate);
      info.appendChild(name);

      var value = document.createElement("div");
      value.className = "frete-valor";
      value.textContent = describePrice(rate);

      item.appendChild(info);
      item.appendChild(value);
      freteLista.appendChild(item);
    });

    freteLista.setAttribute("style", "display:block");
  };

  var getRates = function (variantId) {
    var productQuantity = document.getElementById("Quantity");
    var quantity = productQuantity ? parseInt(productQuantity.value, 10) : 1;

    fetch("/cart/add.js?_easygift_internal=true", {
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 }),
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      method: "POST",
    })
      .then(function (response) {
        return response.json();
      })
      .then(function () {
        $.ajax({
          type: "GET",
          url: "/cart/shipping_rates.json?_easygift_internal=true",
          data: {
            "shipping_address[country]": shippingCountry.value,
            "shipping_address[province]": shippingProvince.value,
            "shipping_address[zip]": shippingZip.value,
          },
          success: function (response) {
            renderRates(response.shipping_rates || []);
            resetCartCookie();
            setLoading(false);
          },
          error: function () {
            resetCartCookie();
            showError("Cep não encontrado, tente novamente.");
            setLoading(false);
          },
          dataType: "json",
        });
      })
      .catch(function () {
        resetCartCookie();
        showError("Não foi possível calcular o frete. Tente novamente.");
        setLoading(false);
      });
  };

  var calculate = function () {
    var cepLimpo = shippingZip.value.replace(/\D/g, "");

    if (cepLimpo.length !== 8) {
      showError("Digite um CEP válido com 8 dígitos.");
      return;
    }

    setLoading(true);
    clearError();

    $.getJSON(
      "https://viacep.com.br/ws/" + cepLimpo + "/json/?callback=?",
      function (dados) {
        if ("erro" in dados) {
          showError("Cep não encontrado, tente novamente.");
          setLoading(false);
          return;
        }

        shippingProvince.value = PROVINCES[dados.uf] || dados.uf;

        cartCookie = getCookie("cart");
        if (!cartCookie) {
          updateCartCookie("temp-cart-cookie___" + Date.now());
          cartCookie = getCookie("cart");
        }

        if (!cartCookie || cartCookie.length < 32) {
          showError("Não foi possível calcular o frete. Tente novamente.");
          setLoading(false);
          return;
        }

        var variantId = parseInt(productSelect.value, 10);
        if (!variantId && productSelect.options && productSelect.options[1]) {
          variantId = parseInt(productSelect.options[1].value, 10);
        }

        if (!variantId) {
          showError("Selecione uma variação do produto para calcular o frete.");
          setLoading(false);
          return;
        }

        updateCartCookie("fake-cart-cookie___" + Date.now());
        getRates(variantId);
      }
    ).fail(function () {
      showError("Cep não encontrado, tente novamente.");
      setLoading(false);
    });
  };

  var initFields = function () {
    shippingCountry.id = "pais-simulator";
    shippingCountry.name = "shipping_address[country]";
    shippingCountry.add(new Option("Brazil", "Brazil", true, true));

    shippingProvince.id = "estados-simulator";
    shippingProvince.name = "shipping_address[province]";
    Object.keys(PROVINCES).forEach(function (uf, index) {
      shippingProvince.add(
        new Option(PROVINCES[uf], PROVINCES[uf], index === 0)
      );
    });

    shippingZip.type = "text";
    shippingZip.name = "shipping_address[zip]";
    shippingZip.className = "cep-calculo-frete";
    shippingZip.placeholder = "Digite seu CEP";
    shippingZip.inputMode = "numeric";
    shippingZip.autocomplete = "postal-code";
    shippingZip.setAttribute("aria-label", "CEP para cálculo de frete");
    $(shippingZip).mask("00.000-000");

    shippingCalcButton.type = "button";
    shippingCalcButton.className = "btn";
    shippingCalcButton.textContent = "Calcular";
    shippingCalcButton.addEventListener("click", calculate);

    shippingZip.addEventListener("keydown", function (event) {
      if (event.key === "Enter") {
        event.preventDefault();
        calculate();
      }
    });

    var shippingCalcWrapper = document.createElement("div");
    shippingCalcWrapper.className = "shipping-calc-wrapper";

    var formularioFrete = document.createElement("div");
    formularioFrete.className = "formulario-frete";

    formularioFrete.appendChild(shippingCountry);
    formularioFrete.appendChild(shippingProvince);
    formularioFrete.appendChild(shippingZip);
    formularioFrete.appendChild(shippingCalcButton);

    shippingCalcWrapper.appendChild(formularioFrete);
    shippingCalcWrapper.appendChild(shippingMessage);
    shippingCalcWrapper.appendChild(freteLista);

    productSection[0].appendChild(shippingCalcWrapper);
  };

  initFields();
})();
